import { Box, Collapse, IconButton, Typography } from '@mui/material'
import React, { PropsWithChildren, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'

interface AlertProps extends PropsWithChildren {
  title: string
  variant: 'success' | 'error' | 'info' | 'warning'
  closable?: boolean
  showAlert?: boolean
}

export const Alert: React.FC<AlertProps> = ({
  title,
  variant,
  closable = true,
  showAlert,
}) => {
  const [isAlertCanceled, setIsAlertCanceled] = useState(false)

  return (
    <Collapse in={!isAlertCanceled && showAlert} unmountOnExit>
      <Box
        role="alert"
        bgcolor={`${variant}.light`}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
          minHeight: 35,
        }}
      >
        <Typography variant="body2" marginX="auto">
          {title}
        </Typography>
        {closable && (
          <IconButton onClick={() => setIsAlertCanceled(true)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
    </Collapse>
  )
}
